import { Update } from 'src/shared/types/update';

type UpdateStatus = 'action' | 'update' | 'from-you' | 'resolved' | 'question';

const getUpdateStatus = (update: Update): UpdateStatus => {
  if (!update.relevant) {
    return 'resolved';
  }

  if (update.update_type === 'block') {
    return 'action';
  }

  // Answered question waiting for manual resolution
  if (update.question?.answer != null) {
    return 'question';
  }

  if (
    update.update_type === 'in-progress' ||
    update.update_type === 'complete' ||
    update.update_type === 'supplier-update'
  ) {
    return 'update';
  }

  if (!!update?.clarification?.from_user_id) {
    return 'from-you';
  }

  return 'update';
};

export default getUpdateStatus;
